<template>
  <div class="user">
    <top-bar>
      <template slot="main">
        <permission-wrapper
          skip-alert
          page-name="user"
          resource-name="user"
          action-name="read_foreign">
          <router-link :to="vueRoutes.userDetails">
            <span>{{ "user.details-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>

        <permission-wrapper
          skip-alert
          page-name="businesses"
          resource-name="kyb_session"
          action-name="read">
          <router-link :to="vueRoutes.userBusinessList">
            <span>{{ "user.businesses-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>
        <permission-wrapper
          skip-alert
          page-name="verifications"
          resource-name="verification"
          action-name="read_foreign">
          <router-link :to="vueRoutes.userVerifications">
            <span>{{ "user.verifications-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>
        <permission-wrapper
          skip-alert
          page-name="verifications"
          resource-name="verification"
          action-name="read_foreign">
          <router-link :to="vueRoutes.userCDDs">
            <span>{{ "user.cdds-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>
        <permission-wrapper
          skip-alert
          page-name="verifications"
          resource-name="verification"
          action-name="read_foreign">
          <router-link :to="vueRoutes.userBDDs">
            <span>{{ "user.bdds-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>
        <permission-wrapper
          skip-alert
          page-name="users"
          resource-name="nft_permissions"
          action-name="read">
          <router-link :to="vueRoutes.userTransactions">
            <span>{{ "user.transactions-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>
        <permission-wrapper
          skip-alert
          page-name="verifications"
          resource-name="verification"
          action-name="read_foreign">
          <router-link :to="vueRoutes.userVerificationComments">
            <span>{{ "user.vericicationComments-tab" | globalize }}</span>
          </router-link>
        </permission-wrapper>
      </template>
    </top-bar>
    <router-view />
  </div>
</template>

<script>
import PermissionWrapper from '@/vue/common/permission-wrapper'
import TopBar from '@/vue/common/TopBar'
import { vueRoutes } from '@/vue-router/routes'

export default {
  name: 'user',
  components: {
    TopBar,
    PermissionWrapper,
  },
  props: {
    id: { type: [Number, String], required: true },
  },
  data () {
    return {
      vueRoutes,
    }
  },
}
</script>
